import { useTranslation } from "react-i18next";
import { cn } from "@nexus/ui";
import { TONE_BG } from "../../constants/result-state";
import { bandTone } from "../../lib/score-band";
import type { BandTone } from "../../lib/score-band";
import type { PreflightScoreBand } from "../../types/preflight.types";

/** Pill surface — the subtle token pair, which holds AA contrast at pill text sizes. */
const PILL_CLASS: Record<BandTone, string> = {
  success: "bg-success-subtle text-success-subtle-foreground",
  warning: "bg-warning-subtle text-warning-subtle-foreground",
  error: "bg-error-subtle text-error-subtle-foreground",
};

/**
 * Score band as a compact pill: a tone dot next to its label, so the band never rides on
 * colour alone. Shared by the hover panels behind the score rail and the criteria heatmap.
 */
export function BandPill({
  band,
  className,
}: {
  band: PreflightScoreBand;
  className?: string;
}) {
  const { t } = useTranslation();
  const tone = bandTone(band);
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-medium",
        PILL_CLASS[tone],
        className,
      )}
    >
      <span
        className={cn("size-1.5 rounded-full", TONE_BG[tone])}
        aria-hidden
      />
      {t(`preflight.band.${band}`)}
    </span>
  );
}
